__turbopack_context__.v({
  "SWatchlistSvg": "IFQdoW_SWatchlistSvg",
  "SWatchlistSvgGradient": "IFQdoW_SWatchlistSvgGradient",
});
